"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecodedToken = getDecodedToken;
var database_1 = require("@skillrecordings/database");
var jwt_1 = require("next-auth/jwt");
function loadUserForToken(_a) {
    return __awaiter(this, arguments, void 0, function (_b) {
        var userId, deviceAccessToken;
        var token = _b.token, deviceToken = _b.deviceToken;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!token) return [3 /*break*/, 1];
                    userId = token.id;
                    return [3 /*break*/, 3];
                case 1:
                    if (!deviceToken) return [3 /*break*/, 3];
                    return [4 /*yield*/, database_1.prisma.deviceAccessToken.findFirst({
                            where: {
                                token: deviceToken,
                            },
                            select: {
                                userId: true,
                            },
                        })];
                case 2:
                    deviceAccessToken = _c.sent();
                    if (deviceAccessToken === null || deviceAccessToken === void 0 ? void 0 : deviceAccessToken.userId) {
                        userId = deviceAccessToken.userId;
                    }
                    _c.label = 3;
                case 3:
                    if (!userId) return [3 /*break*/, 5];
                    return [4 /*yield*/, database_1.prisma.user.findUnique({
                            where: {
                                id: userId,
                            },
                            include: {
                                purchases: true,
                            },
                        })];
                case 4: return [2 /*return*/, _c.sent()];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getDecodedToken(params, deviceToken) {
    return __awaiter(this, void 0, void 0, function () {
        var token, user, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    token = (0, jwt_1.getToken)(params);
                    if (!deviceToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadUserForToken({ deviceToken: deviceToken })];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = undefined;
                    _b.label = 3;
                case 3:
                    user = _a;
                    return [2 /*return*/, user || token || null];
            }
        });
    });
}
